import { forwardRef } from 'react';
import { TextField } from '@mui/material';

interface PhoneProps {
  placeholder?: string;
  name?: string;
  label?: string;
}

const NewPhoneInput = forwardRef((props: PhoneProps, ref) => {
  const { placeholder, name, label, ...other } = props;
  return (
    <TextField
      {...other}
      inputRef={ref}
      fullWidth
      variant="standard"
      name={name}
      label={label}
      placeholder={placeholder}
    />
  );
});

NewPhoneInput.displayName = 'NewPhoneInput';

export default NewPhoneInput;
